import React from 'react';

import Header from './Header';
import {disciplines} from './constants';

const DisciplineTips3 = ({score}) => {
    const discipline = disciplines['3'];

    return (
        <div className={'ohs-discipline'}>
            <Header/>

            <div className={'ohs-discipline__content ohs-content-padding'}>
                <h2 className={'ohs-discipline__heading'}>{discipline.header}</h2>

                <p className={'ohs-discipline__score-text'}>{discipline[score]}</p>

                <h3 className={'ohs-discipline__tips-heading'}>Tips for Over-Communicating Clarity:</h3>
                <p className={'ohs-discipline__tips-intro'}>
                    There are a few simple tools that serve to communicate an organization’s sense of clarity:
                </p>

                <ol className={'ohs-discipline__tips-list'}>
                    <li>
                        <b>Repeat, repeat, repeat:</b>
                        <p>
                            Repetition is one of the most powerful and underutilized characteristics of good
                            communication from a leadership team. However, too many leaders shy away from it because
                            they get bored saying the same messages again and again, and because they want to avoid
                            criticism for appearing redundant and potentially condescending. Ironically, most leaders
                            complain that employees do not remember or act upon the messages they deliver, and yet they
                            are reluctant to repeat that message.
                        </p>
                    </li>
                    <li>
                        <b>Keep it simple:</b>
                        <p>
                            Another key to effective communication is the ability to avoid overcomplicating key
                            messages. Years of education and training make most leaders feel compelled to use all of
                            their intellectual capabilities when speaking or writing. While this is certainly
                            understandable, it only serves to confuse employees. What employees need from leaders is
                            clear, uncomplicated messages about where the organization is headed and how they can
                            contribute to getting there.
                        </p>
                    </li>
                    <li>
                        <b>Use multiple mediums:</b>
                        <p>
                            All too often, executives feel comfortable using just one particular form of communication
                            to convey messages to the rest of the organization. Some leaders prefer live communication,
                            either to large groups or in more intimate settings. Others feel more comfortable writing
                            messages through email or internal messages. Still others prefer to communicate primarily to
                            their direct reports, who are then charged with relaying messages to employees deeper in the
                            organization. Which of these methods is best? All of them. For example, live communication
                            provides opportunities for meaningful interaction and emotional context; email allows for
                            more extensive information to be received and maintained for later review; and relayed
                            communication from an employee’s manager creates an opportunity for in-depth discussion
                            about how the message will impact people’s daily jobs.
                        </p>
                    </li>
                    <li>
                        <b>Cascade key messages:</b>
                        <p>
                            At the end of each leadership team meeting, agree on the key messages that need to be
                            communicated and commit to sharing them with your direct reports within 24 to 48 hours. Then
                            ensure those leaders do the same with their teams, cascading the message throughout the
                            organization until everyone is aligned.
                        </p>
                    </li>
                </ol>
            </div>
        </div>
    );
};

export default DisciplineTips3;
